/**
 * Inservice External Integrations
 * Inservice external integrations API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SupportedCalendarProviderDto { 
    id: string;
    name: string;
    description: string;
    image: string;
    providerType: SupportedCalendarProviderDto.ProviderTypeEnum;
    isEnabled: boolean;
}
export namespace SupportedCalendarProviderDto {
    export type ProviderTypeEnum = 'google' | 'office365' | 'icloud' | 'outlook';
    export const ProviderTypeEnum = {
        Google: 'google' as ProviderTypeEnum,
        Office365: 'office365' as ProviderTypeEnum,
        Icloud: 'icloud' as ProviderTypeEnum,
        Outlook: 'outlook' as ProviderTypeEnum
    };
}


